// Car Categories and Transmission Types Helper
// Centralized definitions for car-related dropdown options
import moment from "moment";

export function getCarCategories(t) {
  return [
    {
      value: "MID_SIZE",
      label: t("CarReservationForm.carCategories.MidSizeCar")
    },
    {
      value: "SMALL",
      label: t("CarReservationForm.carCategories.SmallCar")
    },
    {
      value: "LARGE",
      label: t("CarReservationForm.carCategories.LargeCar")
    },
    {
      value: "SUV",
      label: t("CarReservationForm.carCategories.SUV")
    },
    {
      value: "MINIVAN",
      label: t("CarReservationForm.carCategories.Minivan")
    },
    {
      value: "LUXURY",
      label: t("CarReservationForm.carCategories.LuxuryCar")
    },
    {
      value: "STATION",
      label: t("CarReservationForm.carCategories.StationWagon")
    }
  ];
}

export function getCarTransmissionTypes(t) {
  return [
    {
      value: "MANUAL",
      label: t("CarReservationForm.carTransmissionTypes.Manual")
    },
    {
      value: "AUTOMATIC",
      label: t("CarReservationForm.carTransmissionTypes.Automatic")
    }
  ];
}

// Date/Time formatting functions for car reservations
export function formatDateTime(date) {
  return moment(date).format("DD/MM/YYYY HH:mm");
}

// Driver management helper functions
export function createDriverFromEmployee(employee, businessUnit = null) {
  return {
    id: employee.id,
    firstName: employee.firstName,
    lastName: employee.lastName,
    emailAddress: employee.emailAddress
  };
}

export function createUnlistedDriver(employee) {
  return {
    id: null,
    firstName: employee.firstName,
    lastName: employee.lastName,
    emailAddress: employee.emailAddress
  };
}

export function createPersonalDriver(companyInfo) {
  return {
    id: companyInfo?.id,
    emailAddress: companyInfo?.emailAddress
  };
}

// Form validation helpers
export function validateCarDates(pickupDate, returnDate, t) {
  const errors = [];

  if (pickupDate >= returnDate) {
    errors.push(t("error.dateBefore"));
  }

  return errors;
}

export function validateCarLocations(pickupLocation, returnLocation, t) {
  const errors = [];

  if (!pickupLocation || !returnLocation) {
    errors.push(t("error.locationMandatory"));
  }

  return errors;
}

export function validateBusinessUnit(companyInfo, selectedBusinessUnit, t) {
  const errors = [];

  if (companyInfo.businessUnitMandatory && !selectedBusinessUnit) {
    errors.push(t("error.businessunitMandatory"));
  }

  return errors;
}

export function validateDriver(driver, t) {
  const errors = [];

  if (!driver || Object.keys(driver).length === 0) {
    errors.push(t("error.employeeMandatory"));
  }

  return errors;
}

export function validateCustomFields(
  customFields,
  customFieldFormData,
  getFieldNameTranslation,
  t
) {
  const errors = [];
  const invalidCustomFields = [];

  customFields.forEach((field) => {
    if (field.mandatory) {
      if (
        !customFieldFormData[field.name] ||
        customFieldFormData[field.name] === ""
      ) {
        invalidCustomFields.push(getFieldNameTranslation(field));
      }
    }
  });

  if (invalidCustomFields.length > 0) {
    let message = t("error.customFields");
    message += ` (${invalidCustomFields.join(", ")})`;
    errors.push(message);
  }

  return errors;
}

// Reservation data preparation
export function prepareCarReservationData(formData) {
  const {
    notes,
    pickupDateCar,
    pickupLocation,
    returnDateCar,
    returnLocation,
    selectedCarClass,
    selectedCarTransmissionType,
    selectedBusinessUnit,
    driver,
    customFieldFormData
  } = formData;

  const businessUnitId = selectedBusinessUnit ? selectedBusinessUnit.id : null;

  const reservation = {
    notes: notes,
    carPickupDate: moment(pickupDateCar).format("YYYY-MM-DD"),
    carPickupTimeStamp: moment(pickupDateCar).format("HH:mm:ss"),
    carPickupLocation: pickupLocation,
    carReturnDate: moment(returnDateCar).format("YYYY-MM-DD"),
    carReturnTimeStamp: moment(returnDateCar).format("HH:mm:ss"),
    carReturnLocation: returnLocation,
    customFields: customFieldFormData || {},
    carClass: selectedCarClass,
    TransmissionType: selectedCarTransmissionType,
    businessUnitId: businessUnitId,
    Driver: driver,
    vehicleType: "RENTAL_CAR"
  };

  // Add custom fields to reservation
  if (customFieldFormData) {
    Object.keys(customFieldFormData).forEach((key) => {
      reservation.customFields[key] = customFieldFormData[key];
    });
  }

  return {
    reservationList: [reservation]
  };
}

// Track data preparation for analytics
export function prepareCarTrackingData(formData, status = "success") {
  const {
    selectedCarClass,
    selectedCarTransmissionType,
    pickupLocation,
    pickupDateCar,
    returnLocation,
    returnDateCar
  } = formData;

  return {
    reservationType: "car",
    carCategory: selectedCarClass,
    transmissionType: selectedCarTransmissionType,
    pickupLocation: pickupLocation,
    pickupDateCar: pickupDateCar,
    returnLocation: returnLocation,
    returnDateCar: returnDateCar,
    status: status
  };
}
